import React from 'react';
import moment from 'moment';
import './App.css';
import { useTranslation } from 'react-i18next';
import { Packet } from './api/Models';
import { Button } from '@fluentui/react-components';
import { RowsPhotoAlbum } from 'react-photo-album';
import "react-photo-album/rows.css";
import Lightbox from 'yet-another-react-lightbox';
import "yet-another-react-lightbox/styles.css";

import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

export interface PacketDetailProps {
  packet: Packet;
  packetBuy: () => Promise<void>;
  back: () => void;
}

function PacketDetail({packet, packetBuy, back}: PacketDetailProps) {
  const [index, setIndex] = React.useState(-1);
  const { t } = useTranslation();

  const packetDateTime = (packet && packet.ts)?moment(packet.ts, "YYYY-MM-DD hh:mm:ss").format(t('packteDateTimeFormat')):'';
  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <div className='pktDet'>
        <p style={{marginBlockStart: '4px', marginBlockEnd: '4px'}}>{t('photosTakenLbl')} {packetDateTime}</p><p style={{marginBlockStart: '4px', marginBlockEnd: '4px'}}>{t('priceLbl')} {packet.amount} {t('currencyLbl')}</p>
      </div>
      <div style={{flex: '1 1 0', display: 'flex', gap: '5px', flexDirection: 'row', justifyContent: 'center', padding: '4px'}}>
        <Button appearance="primary" onClick={packetBuy}>{t('buyBtn')}</Button>
        <Button appearance="secondary" onClick={back}>{t('backBtn')}</Button>
      </div>
      <RowsPhotoAlbum 
         photos={packet.images} 
         targetRowHeight={150} 
         rowConstraints={{maxPhotos: 5, singleRowMaxHeight: 200}}
         onClick={({ index }) => setIndex(index)} 
         />

      <Lightbox
        slides={packet.images}
        open={index >= 0}
        index={index}
        close={() => setIndex(-1)}
        // enable optional lightbox plugins
        plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
      />
    </div>
  );
}

export default PacketDetail;
